import clsx from "clsx";
import React from "react";

import { Product as ProductImage } from "@components/products/product";

export const ProductDropdownOption = ({
  product,
  productImagesEnabled,
  className,
}) => {
  const optionText = product.displayName;

  return (
    <div className={clsx("product-dropdown-option", className)}>
      {productImagesEnabled && (
        <ProductImage productId={product?.id}></ProductImage>
      )}
      <span title={optionText}>{optionText}</span>
    </div>
  );
};
